import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SelectDropdown from "../../components/components-react/SelectDropdown";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import {
  paymentModesSubs,
  planTypes,
  installmentModes,
} from "../../components/common-data/DropdowData";
import {
  fetchAllAddonSessionsData,
  fetchAllAddonSlotsData,
  fetchAllAddonsByGymData,
  fetchAllTrainersByExpLvlData,
  fetchAllTrainersSlotsData,
  fetchAllUnmappedUserData,
} from "../../redux/reducers/apiSlice";
import { createFetchPlans } from "../../redux/reducers/postApiSlice";
import { currentMonthCurrentDate } from "../../components/common-data/Converts";
import { fetchSourceNameData } from "../../redux/reducers/dropdownApiSlice";
import SelectDropdownDynamic from "../../components/components-react/SelectDropdownDynamic";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const AddSubscription = ({
  decryptedText,
  createSubsFormData,
  setCreateSubsFormData,
  createSubsFormErrors,
  gstTableValues,
  onClickSubmit,
  isSubmitting = false,
  isUserPreSelected = false,
  preSelectedUserData = null,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const {
    unmappedUserData,
    allAddonsByGymData,
    allAddonSessions,
    allTrainerByExpLvlData,
    trainerSlotDetails,
  } = useSelector((state) => state.api);
  const { sourceNames } = useSelector((state) => state.dropdown);
  const isAdmin = decryptedText?.account_type === "admin";
  const isManagerRole = checkIsManagerRole(decryptedText);
  const canSelectGym = isAdmin || isManagerRole;

  const today = new Date().toISOString().split("T")[0];

  const [allUsersData, setAllUsersData] = useState([]);
  const initialAllPansData = {
    allPlansData: [],
    allPlansDropdownData: [],
    selectedPlanInfo: [],
  };
  const [allPlans, setAllPlans] = useState(initialAllPansData);
  const initialAddonsData = {
    allAddonsData: [],
    allAddonsDropdownData: [],
  };
  const [allAddons, setAllAddons] = useState(initialAddonsData);
  const initialSessionData = {
    allSessionsData: [],
    allSessionsDropdownData: [],
    selectedAddonSessionInfo: [],
  };
  const [allSessions, setAllSessions] = useState(initialSessionData);
  const [allTrainersData, setAllTrainerData] = useState([]);
  const [allTrainersSlotData, setAllTrainersSlotData] = useState([]);
  const iniDrodpdown = {
    page: 1,
    totalPages: 1,
    search: "",
  };
  const [dropdownData, setDropdownData] = useState(iniDrodpdown);

  const onChangeFormValues = (name, selectedValue) => {
    if (name === "selectedType") {
      setCreateSubsFormData({
        ...createSubsFormData,
        selectedPlan: "",
        selectedSession: "",
        enteredSlotDate: "",
        selectedSlotIndex: "",
        enteredSlotStartTime: "",
        enteredSlotEndTime: "",
        trainerExpLvl: "",
        selectedTrainer: "",
        selectedSlotID: "",
        isPT: 0,
        [name]: selectedValue,
      });
      setAllTrainersSlotData([]);
      setAllTrainerData([]);
    } else if (name === "selectedPlan") {
      setCreateSubsFormData({
        ...createSubsFormData,
        selectedSession: "",
        enteredSlotDate: "",
        selectedSlotIndex: "",
        enteredSlotStartTime: "",
        enteredSlotEndTime: "",
        trainerExpLvl: "",
        selectedTrainer: "",
        selectedSlotID: "",
        isPT: 0,
        [name]: selectedValue,
      });
      setAllTrainersSlotData([]);
      setAllTrainerData([]);
    } else if (name === "selectedSession") {
      setCreateSubsFormData({
        ...createSubsFormData,
        enteredSlotDate: "",
        selectedSlotIndex: "",
        enteredSlotStartTime: "",
        enteredSlotEndTime: "",
        trainerExpLvl: "",
        selectedTrainer: "",
        selectedSlotID: "",
        isPT: 0,
        [name]: selectedValue,
      });
      setAllTrainersSlotData([]);
      setAllTrainerData([]);
    } else if (name === "installment1Mode") {
      // Cash mode hides the Trx ID input — drop any stale value so the
      // payload sends a clean 'cash' literal without leftover digits.
      setCreateSubsFormData({
        ...createSubsFormData,
        installment1Mode: selectedValue,
        enteredTrxId:
          selectedValue?.value === "cash" ? "" : createSubsFormData.enteredTrxId,
      });
    } else {
      setCreateSubsFormData({
        ...createSubsFormData,
        [name]: selectedValue,
      });
    }
  };

  const handleSelectSlot = (index, start, end, slotId) => {
    console.log(index, start, end, slotId);

    if (index === createSubsFormData.selectedSlotIndex) {
      setCreateSubsFormData({
        ...createSubsFormData,
        selectedSlotIndex: "",
        selectedSlotStartTime: "",
        selectedSlotEndTime: "",
        selectedSlotID: "",
      });
    } else {
      setCreateSubsFormData({
        ...createSubsFormData,
        selectedSlotIndex: index,
        selectedSlotStartTime: start,
        selectedSlotEndTime: end,
        selectedSlotID: slotId,
      });
    }
  };

  // ALL PALNS
  const handleCreateFetchPlans = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(createFetchPlans({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data) {
        setAllPlans({ ...allPlans, allPlansData: result.payload.data });
      } else {
        const errorMessage = result?.error?.message;
        console.log("errorMessage=> ", errorMessage);
      }
    } catch (error) {
      console.log("handleCreateFetchPlans ERROR => ", error);
    }
  };
  // ----------------- ALL PALNS ------------------

  // GEETING DATAS
  function getSourceName(filter) {
    dispatch(
      fetchSourceNameData({
        filters: filter,
        token: decryptedText?.token,
      })
    );
  }

  function getUnmappedUsers(finalQP, pageNo) {
    dispatch(
      fetchAllUnmappedUserData({
        pageNo: pageNo,
        pageLimit: 10,
        queryParameters: finalQP,
        token: decryptedText?.token,
      })
    );
  }
  // ------------------------- GEETING DATAS --------------------------

  const handleSearchChange = (inputValue) => {
    setDropdownData((prev) => ({
      ...prev,
      page: 1,
      search: inputValue,
    }));
  };

  const fetchMoreData = () => {
    if (dropdownData.page + 1 <= dropdownData.totalPages) {
      setDropdownData((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  const fetchPreviousData = () => {
    setDropdownData((prev) => ({
      ...prev,
      page: Math.max(prev.page - 1, 1),
    }));
  };

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 200,
    };
    getSourceName(filters);
  }, []);

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, []);

  useEffect(() => {
    if (
      isManagerRole &&
      gymData?.length === 1 &&
      !createSubsFormData.selectedGym?.value
    ) {
      const onlyGym = gymData[0];
      onChangeFormValues("selectedGym", {
        label: onlyGym?.label,
        value: onlyGym?.value,
      });
    }
  }, [isManagerRole, gymData, createSubsFormData.selectedGym?.value]);

  useEffect(() => {
    let gymQP = createSubsFormData.selectedGym?.value
      ? `&gym_id=${createSubsFormData.selectedGym.value}`
      : "";
    let searchQP = dropdownData.search ? `&search=${dropdownData.search}` : "";
    const finalQP = gymQP + searchQP;

    getUnmappedUsers(finalQP, dropdownData.page);
  }, [
    createSubsFormData.selectedGym?.value,
    dropdownData.page,
    dropdownData.search,
  ]);

  // FETCH REGULAR PLAN | ADDON | ADDON SESSION | TRAINER | TRAINER SLOT | ADDON SLOTS
  useEffect(() => {
    const selectedGymQueryParam = createSubsFormData?.selectedGym?.value
      ? `&gym_id=${createSubsFormData?.selectedGym.value}`
      : "";
    const expLvlQueryParam = createSubsFormData.trainerExpLvl
      ? `&trainer_exp_lvl=${createSubsFormData.trainerExpLvl}`
      : "";
    const queryParametersForTrainer = `${selectedGymQueryParam}${expLvlQueryParam}`;

    // PT (addon_pt) reuses the addon data pipeline — plans, sessions, trainers
    // and slots all come from the same backend. Treating it as "addon-like"
    // keeps the existing Addon flow untouched while enabling PT selection.
    const typeVal = createSubsFormData.selectedType?.value;
    const isAddonLike = typeVal === "addon" || typeVal === "addon_pt";

    if (typeVal === "regular") {
      handleCreateFetchPlans(
        {
          gym_id: createSubsFormData.selectedGym?.value || "",
        },
        decryptedText?.token
      );
    } else if (isAddonLike) {
      // For Addon type, fetch all gym addons (no is_pt filter).
      // For PT (addon_pt) type, restrict to PT addons only (is_pt=1).
      const addonFetchPayload = {
        gymId: createSubsFormData.selectedGym?.value || "",
        token: decryptedText?.token,
      };
      if (typeVal === "addon_pt") {
        addonFetchPayload.isPT = 1;
      }
      dispatch(fetchAllAddonsByGymData(addonFetchPayload));
    }

    if (isAddonLike && createSubsFormData.selectedPlan) {
      dispatch(
        fetchAllAddonSessionsData({
          addonId: createSubsFormData.selectedPlan?.value,
          token: decryptedText?.token,
        })
      );
    }

    if (isAddonLike && expLvlQueryParam) {
      dispatch(
        fetchAllTrainersByExpLvlData({
          queryParameters: queryParametersForTrainer,
          token: decryptedText?.token,
        })
      );
    }

    if (createSubsFormData.selectedTrainer?.value) {
      dispatch(
        fetchAllTrainersSlotsData({
          trainerSlot: createSubsFormData.selectedTrainer.value,
          token: decryptedText?.token,
        })
      );
    }

    if (
      createSubsFormData.selectedPlan?.value &&
      createSubsFormData.enteredSlotDate
    ) {
      dispatch(
        fetchAllAddonSlotsData({
          addonId: createSubsFormData.selectedPlan.value,
          slotDate:
            (createSubsFormData.enteredSlotDate &&
              moment(createSubsFormData.enteredSlotDate).tz("Asia/Kolkata").format(
                "DD-MM-YYYY"
              )) ||
            "",
          token: decryptedText?.token,
        })
      );
    }
  }, [
    createSubsFormData.selectedGym,
    createSubsFormData.selectedType,
    createSubsFormData.selectedPlan,
    createSubsFormData.trainerExpLvl,
    createSubsFormData.trainerExpLvl,
    createSubsFormData.enteredSlotDate,
    createSubsFormData.selectedTrainer?.value,
  ]);
  // ----------- FETCH REGULAR PLAN | ADDON | ADDON SESSION | TRAINER | TRAINER SLOT | ADDON SLOTS ------------

  // REGULAR | ADDON | SESSION | TRAINER DROPDOWN DATA | RAINER SLOT
  useEffect(() => {
    if (
      allPlans?.allPlansData?.length > 0 &&
      createSubsFormData.selectedType?.value === "regular"
    ) {
      const allPlansDropdownDataFind = allPlans.allPlansData.map((plan) => {
        return {
          label: `${plan.plan_name}/${plan.duration}Days`,
          value: plan.plan_uid,
        };
      });

      setAllPlans({
        ...allPlans,
        allPlansDropdownData: allPlansDropdownDataFind,
      });
    } else {
      setAllPlans({
        ...allPlans,
        allPlansDropdownData: [],
      });
    }

    const typeValInner = createSubsFormData.selectedType?.value;
    const isAddonLikeInner =
      typeValInner === "addon" || typeValInner === "addon_pt";

    if (
      isAddonLikeInner &&
      allAddonsByGymData?.status &&
      allAddonsByGymData?.data?.length > 0
    ) {
      const allAddonsDropdownDataFind = allAddonsByGymData.data.map((addon) => {
        return {
          label: addon.name,
          value: addon.uid,
        };
      });
      setAllAddons({
        ...allAddons,
        allAddonsData: allAddonsByGymData.data,
        allAddonsDropdownData: allAddonsDropdownDataFind,
      });
    } else {
      setAllAddons({
        ...allAddons,
        allAddonsData: [],
        allAddonsDropdownData: [],
      });
    }

    if (
      isAddonLikeInner &&
      createSubsFormData.selectedPlan &&
      allAddonSessions?.status &&
      allAddonSessions?.data?.length > 0
    ) {
      const allAddonsSessionsDropdownDataFind = allAddonSessions.data.map(
        (addon) => {
          return {
            label:
              `${addon?.n_session} Sessions for ${addon?.duration} Day(s)` ||
              "",
            value: addon?.uid || "",
          };
        }
      );

      setAllSessions({
        ...allSessions,
        allSessionsData: allAddonSessions.data,
        allSessionsDropdownData: allAddonsSessionsDropdownDataFind,
      });
    } else {
      setAllSessions({
        ...allSessions,
        allSessionsData: [],
        allSessionsDropdownData: [],
      });
    }

    if (
      isAddonLikeInner &&
      allTrainerByExpLvlData?.status &&
      allTrainerByExpLvlData?.data
    ) {
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainerData(trainers);
    }

    if (isAddonLikeInner && trainerSlotDetails?.data) {
      const slotDetailsData = trainerSlotDetails.data?.slot_details || null;

      setAllTrainersSlotData(slotDetailsData);
    } else {
      setAllTrainersSlotData([]);
    }
  }, [
    allPlans.allPlansData,
    createSubsFormData.selectedType?.value,
    allAddonsByGymData,
    allAddonSessions,
    createSubsFormData.selectedPlan?.value,
    allTrainerByExpLvlData,
  ]);
  // --------- REGULAR | ADDON | SESSION | TRAINER DROPDOWN DATA | RAINER SLOT ----------

  // PRICE | IS_PT
  useEffect(() => {
    if (
      allPlans?.allPlansData?.length > 0 &&
      createSubsFormData.selectedType?.value === "regular" &&
      createSubsFormData.selectedPlan?.value
    ) {
      const selectedPlanIfo = allPlans.allPlansData?.filter(
        (plan) => plan.plan_uid === createSubsFormData.selectedPlan?.value
      )?.[0];

      setCreateSubsFormData((prev) => ({
        ...prev,
        enteredPrice: selectedPlanIfo?.plan_price || 0,
      }));
    } else if (
      allAddonSessions?.data?.length > 0 &&
      (createSubsFormData.selectedType?.value === "addon" ||
        createSubsFormData.selectedType?.value === "addon_pt") &&
      createSubsFormData.selectedSession?.value
    ) {
      const selectedSessionInfo = allAddonSessions?.data?.filter(
        (addon) => addon?.uid === createSubsFormData.selectedSession?.value
      )?.[0];

      setCreateSubsFormData((prev) => ({
        ...prev,
        enteredPrice: selectedSessionInfo?.price || 0,
        trainerExpLvl: selectedSessionInfo?.trainer_exp_lvl || "",
      }));
    } else {
      setCreateSubsFormData((prev) => ({
        ...prev,
        enteredPrice: 0,
        trainerExpLvl: "",
      }));
    }

    if (
      (createSubsFormData.selectedType?.value === "addon" ||
        createSubsFormData.selectedType?.value === "addon_pt") &&
      createSubsFormData.selectedPlan?.value
    ) {
      const selectedAddon = allAddons.allAddonsData?.filter(
        (addon) => addon?.uid === createSubsFormData.selectedPlan.value
      )?.[0];

      // When user explicitly picks PT type, force isPT=1. When they pick Addon
      // type, derive isPT from the selected addon's is_pt flag (existing
      // behavior — preserves Addon flow untouched).
      if (createSubsFormData.selectedType?.value === "addon_pt") {
        setCreateSubsFormData((prev) => ({
          ...prev,
          isPT: 1,
        }));
      } else if (selectedAddon?.is_pt === "1") {
        setCreateSubsFormData((prev) => ({
          ...prev,
          isPT: 1,
        }));
      } else {
        setCreateSubsFormData((prev) => ({
          ...prev,
          isPT: 0,
        }));
      }
    }
  }, [
    allPlans?.allPlansData,
    allAddonSessions,
    createSubsFormData.selectedType?.value,
    createSubsFormData.selectedPlan?.value,
    createSubsFormData.selectedSession?.value,
    allAddons.allAddonsData,
  ]);
  // ----------- PRICE | IS_PT  -----------

  // AUTO EXPIRE DATE (start_date + plan/session duration + extend_days)
  useEffect(() => {
    const {
      selectedType,
      selectedPlan,
      selectedSession,
      enteredStartDate,
      extendDays,
    } = createSubsFormData;

    if (!enteredStartDate) return;

    let durationDays = 0;

    if (
      selectedType?.value === "regular" &&
      selectedPlan?.value &&
      allPlans.allPlansData?.length > 0
    ) {
      const planInfo = allPlans.allPlansData.find(
        (p) => p.plan_uid === selectedPlan.value
      );
      durationDays = parseInt(planInfo?.duration) || 0;
    } else if (
      (selectedType?.value === "addon" || selectedType?.value === "addon_pt") &&
      selectedSession?.value &&
      allSessions.allSessionsData?.length > 0
    ) {
      const sessionInfo = allSessions.allSessionsData.find(
        (s) => s?.uid === selectedSession.value
      );
      durationDays = parseInt(sessionInfo?.duration) || 0;
    }

    const extraDays = parseInt(extendDays) || 0;
    const totalDays = durationDays + extraDays;

    if (totalDays > 0) {
      const expireDate = moment(enteredStartDate)
        .add(totalDays, "days")
        .format("YYYY-MM-DD");
      setCreateSubsFormData((prev) => ({
        ...prev,
        enteredExpireDate: expireDate,
      }));
    }
  }, [
    createSubsFormData.enteredStartDate,
    createSubsFormData.selectedPlan?.value,
    createSubsFormData.selectedSession?.value,
    createSubsFormData.selectedType?.value,
    createSubsFormData.extendDays,
    allPlans.allPlansData,
    allSessions.allSessionsData,
  ]);
  // ----------- AUTO EXPIRE DATE ------------

  // AUTO 2ND INSTALLMENT (Amount - 1st Installment). Only fires in partial mode.
  // The 2nd installment input is read-only in the UI so this stays the source
  // of truth and can't drift from (enteredPrice - installment1Amount).
  useEffect(() => {
    if (createSubsFormData?.selectedTrxMode?.value !== "partial") return;

    const total = Number(createSubsFormData.enteredPrice) || 0;
    const inst1 = Number(createSubsFormData.installment1Amount) || 0;

    // Only compute when both inputs are present; otherwise blank the 2nd field
    const inst2 =
      total > 0 && inst1 > 0
        ? Math.max(0, total - inst1).toString()
        : "";

    setCreateSubsFormData((prev) =>
      prev.installment2Amount === inst2
        ? prev
        : { ...prev, installment2Amount: inst2 }
    );
  }, [
    createSubsFormData?.selectedTrxMode?.value,
    createSubsFormData?.enteredPrice,
    createSubsFormData?.installment1Amount,
  ]);

  useEffect(() => {
    if (unmappedUserData?.status && unmappedUserData?.data?.length > 0) {
      const userDropdownData = unmappedUserData.data
        .filter((user) => user?.name !== "" && user?.user_id !== "")
        .map((user) => ({
          label: `${user?.name} / ${user?.mobile}`,
          value: user?.user_id,
        }));
      setAllUsersData(userDropdownData);
      setDropdownData((prev) => ({
        ...prev,
        totalPages:
          unmappedUserData?.pagination?.length > 0
            ? unmappedUserData?.pagination[0]?.pagination
            : 0,
      }));
    } else {
      setAllUsersData([]);
      setDropdownData((prev) => ({
        ...prev,
        totalPages: 0,
      }));
    }
  }, [unmappedUserData]);

  return (
    <div className="paymentLinkForm mt-2">
      <form className="formContainer mt-0">
        <div className="formInputsGrid fourGridSystem">
          {canSelectGym ? (
            <div className="formInputBox">
              <label htmlFor="selectedGym" className="formInputLabel">
                Gym <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  createSubsFormErrors.selectedGym && "formError"
                }`}
              >
                <SelectDropdown
                  options={gymData}
                  selectedOption={createSubsFormData.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    onChangeFormValues("selectedGym", selectedValue)
                  }
                  name="Gym"
                />
              </div>
            </div>
          ) : (
            <div className="formInputBox">
              <label htmlFor="gym" className="formInputLabel">
                Selected Gym
              </label>

              <input
                type="text"
                className="formInput"
                name="gym"
                placeholder={`🚫 ${
                  createSubsFormData.selectedGym?.label ||
                  createSubsFormData.selectedGym?.value
                    ? createSubsFormData.selectedGym.label ||
                      createSubsFormData.selectedGym.value
                    : "NA"
                }`}
                disabled
              />
            </div>
          )}

          {isUserPreSelected && preSelectedUserData ? (
            <div className="formInputBox">
              <label htmlFor="selectedUser" className="formInputLabel">
                Member <span className="required">*</span>
              </label>

              <input
                type="text"
                className="formInput"
                name="selectedUser"
                placeholder={`${preSelectedUserData?.name || ""} / ${preSelectedUserData?.mobile || ""}`}
                value={`${preSelectedUserData?.name || ""} / ${preSelectedUserData?.mobile || ""}`}
                disabled
                style={{ cursor: "not-allowed", backgroundColor: "#f5f5f5" }}
              />
            </div>
          ) : (
            <div className="formInputBox">
              <label htmlFor="selectedUser" className="formInputLabel">
                Member <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  createSubsFormErrors.selectedUser && "formError"
                }`}
              >
                <SelectDropdownDynamic
                  options={allUsersData}
                  selectedOption={createSubsFormData.selectedUser}
                  setSelectedOption={(selectedValue) =>
                    onChangeFormValues("selectedUser", selectedValue)
                  }
                  name="Member"
                  onSearchChange={handleSearchChange}
                  fetchMoreData={fetchMoreData}
                  fetchPreviousData={fetchPreviousData}
                />
              </div>
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="selectedType" className="formInputLabel">
              Type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                createSubsFormErrors.selectedType && "formError"
              }`}
            >
              <SelectDropdown
                options={planTypes}
                selectedOption={createSubsFormData.selectedType}
                setSelectedOption={(selectedValue) =>
                  onChangeFormValues("selectedType", selectedValue)
                }
                name="Subscription Type"
              />
            </div>
          </div>

          {createSubsFormData.selectedType?.value === "regular" ? (
            <div className="formInputBox">
              <label htmlFor="selSourceName" className="formInputLabel">
                Source Name <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  createSubsFormErrors.selSourceName && "formError"
                }`}
              >
                <SelectDropdown
                  options={sourceNames?.filter(s => s.label !== "Company Lead" && s.label !== "IVR")}
                  selectedOption={createSubsFormData.selSourceName}
                  setSelectedOption={(selectedValue) =>
                    onChangeFormValues("selSourceName", selectedValue)
                  }
                  name="Source Name"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>
          ) : null}

          {createSubsFormData.selectedType && (
            <div className="formInputBox">
              <label htmlFor="selectedPlan" className="formInputLabel">
                Plan Type <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  createSubsFormErrors.selectedPlan && "formError"
                }`}
              >
                <SelectDropdown
                  options={
                    createSubsFormData.selectedType?.value === "regular"
                      ? allPlans.allPlansDropdownData
                      : allAddons.allAddonsDropdownData
                  }
                  selectedOption={createSubsFormData.selectedPlan}
                  setSelectedOption={(selectedValue) =>
                    onChangeFormValues("selectedPlan", selectedValue)
                  }
                  name="Plan"
                />
              </div>
            </div>
          )}

          {(createSubsFormData.selectedType?.value === "addon" ||
            createSubsFormData.selectedType?.value === "addon_pt") &&
            createSubsFormData.selectedPlan && (
              <>
                <div className="formInputBox">
                  <label htmlFor="selectedSession" className="formInputLabel">
                    Session <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      createSubsFormErrors.selectedSession && "formError"
                    }`}
                  >
                    <SelectDropdown
                      options={allSessions.allSessionsDropdownData}
                      selectedOption={createSubsFormData.selectedSession}
                      setSelectedOption={(selectedValue) =>
                        onChangeFormValues("selectedSession", selectedValue)
                      }
                      name="Session"
                    />
                  </div>
                </div>

                <div className="formInputBox">
                  <label htmlFor="enteredSlotDate" className="formInputLabel">
                    Slot Date <span className="required">*</span>
                  </label>

                  <input
                    type="date"
                    className={`formInput ${
                      createSubsFormErrors.enteredSlotDate && "formError"
                    }`}
                    name="enteredSlotDate"
                    value={createSubsFormData.enteredSlotDate}
                    onChange={(e) =>
                      setCreateSubsFormData({
                        ...createSubsFormData,
                        enteredSlotDate: e.target.value,
                      })
                    }
                    min={today}
                  />
                </div>

                {createSubsFormData.selectedSession && (
                  <div className="formInputBox">
                    <label htmlFor="selectedTrainer" className="formInputLabel">
                      Trainer <span className="required">*</span>
                    </label>

                    <div
                      className={`commonWrapper ${
                        createSubsFormErrors.selectedTrainer && "formError"
                      }`}
                    >
                      <SelectDropdown
                        options={allTrainersData}
                        selectedOption={createSubsFormData.selectedTrainer}
                        setSelectedOption={(selectedValue) =>
                          onChangeFormValues("selectedTrainer", selectedValue)
                        }
                        name="Trainer"
                      />
                    </div>
                  </div>
                )}
              </>
            )}

          <div className="formInputBox">
            <label htmlFor="enteredPrice" className="formInputLabel">
              Amount <span className="required">*</span>
            </label>

            <input
              type="number"
              className={`formInput ${
                createSubsFormErrors.enteredPrice && "formError"
              }`}
              placeholder="Enter Amount"
              name="enteredPrice"
              value={createSubsFormData.enteredPrice}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  enteredPrice: e.target.value,
                })
              }
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedTrxMode" className="formInputLabel">
              Transaction Mode <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                createSubsFormErrors.selectedTrxMode && "formError"
              }`}
            >
              <SelectDropdown
                options={paymentModesSubs}
                selectedOption={createSubsFormData.selectedTrxMode}
                setSelectedOption={(selectedValue) =>
                  onChangeFormValues("selectedTrxMode", selectedValue)
                }
                name="Transaction Mode"
              />
            </div>
          </div>

          {createSubsFormData.selectedTrxMode?.value === "dual" && (
            <>
              <div className="formInputBox">
                <label htmlFor="cashAmount" className="formInputLabel">
                  Cash Amount <span className="required">*</span>
                </label>

                <input
                  type="number"
                  className={`formInput ${
                    createSubsFormErrors.cashAmount && "formError"
                  }`}
                  placeholder="Enter Cash Amount"
                  name="cashAmount"
                  value={createSubsFormData.cashAmount}
                  onChange={(e) =>
                    setCreateSubsFormData({
                      ...createSubsFormData,
                      cashAmount: e.target.value,
                    })
                  }
                  min="0"
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="onlineAmount" className="formInputLabel">
                  Online Amount <span className="required">*</span>
                </label>

                <input
                  type="number"
                  className={`formInput ${
                    createSubsFormErrors.onlineAmount && "formError"
                  }`}
                  placeholder="Enter Online Amount"
                  name="onlineAmount"
                  value={createSubsFormData.onlineAmount}
                  onChange={(e) =>
                    setCreateSubsFormData({
                      ...createSubsFormData,
                      onlineAmount: e.target.value,
                    })
                  }
                  min="0"
                />
              </div>
            </>
          )}

          {createSubsFormData.selectedTrxMode?.value === "partial" && (
            <>
              <div className="formInputBox">
                <label htmlFor="installment1Amount" className="formInputLabel">
                  1st Installment Amount <span className="required">*</span>
                </label>
                <input
                  type="number"
                  className={`formInput ${
                    createSubsFormErrors.installment1Amount && "formError"
                  }`}
                  placeholder="Paid now"
                  name="installment1Amount"
                  value={createSubsFormData.installment1Amount}
                  onChange={(e) =>
                    setCreateSubsFormData({
                      ...createSubsFormData,
                      installment1Amount: e.target.value,
                    })
                  }
                  min="0"
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="installment1Date" className="formInputLabel">
                  1st Installment Date <span className="required">*</span>
                </label>
                <input
                  type="date"
                  className={`formInput ${
                    createSubsFormErrors.installment1Date ? "formError" : ""
                  } ${
                    createSubsFormData.installment1Date ? "date-has-value" : ""
                  }`}
                  name="installment1Date"
                  value={createSubsFormData.installment1Date}
                  onChange={(e) =>
                    setCreateSubsFormData({
                      ...createSubsFormData,
                      installment1Date: e.target.value,
                    })
                  }
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="installment2Amount" className="formInputLabel">
                  2nd Installment Amount <span className="required">*</span>
                </label>
                {/* Auto-fills from (Amount − 1st Installment) but remains
                    editable so the user can override if needed. Note: if the
                    user later changes Amount or 1st Installment, the
                    useEffect will recompute and overwrite the manual value. */}
                <input
                  type="number"
                  className={`formInput ${
                    createSubsFormErrors.installment2Amount && "formError"
                  }`}
                  placeholder="Auto = Amount − 1st (editable)"
                  name="installment2Amount"
                  value={createSubsFormData.installment2Amount}
                  onChange={(e) =>
                    setCreateSubsFormData({
                      ...createSubsFormData,
                      installment2Amount: e.target.value,
                    })
                  }
                  min="0"
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="installment2Date" className="formInputLabel">
                  2nd Installment Due Date <span className="required">*</span>
                </label>
                <input
                  type="date"
                  className={`formInput ${
                    createSubsFormErrors.installment2Date ? "formError" : ""
                  } ${
                    createSubsFormData.installment2Date ? "date-has-value" : ""
                  }`}
                  name="installment2Date"
                  value={createSubsFormData.installment2Date}
                  onChange={(e) =>
                    setCreateSubsFormData({
                      ...createSubsFormData,
                      installment2Date: e.target.value,
                    })
                  }
                />
              </div>

              {/* 3rd installment removed — partial payment now supports max 2 installments */}

              <div className="formInputBox">
                <label htmlFor="installment1Mode" className="formInputLabel">
                  1st Installment Mode <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    createSubsFormErrors.installment1Mode && "formError"
                  }`}
                >
                  <SelectDropdown
                    options={installmentModes}
                    selectedOption={createSubsFormData.installment1Mode}
                    setSelectedOption={(selectedValue) =>
                      onChangeFormValues("installment1Mode", selectedValue)
                    }
                    name="Installment Mode"
                  />
                </div>
              </div>
            </>
          )}

          {(createSubsFormData.selectedTrxMode?.value === "online" ||
            (createSubsFormData.selectedTrxMode?.value === "partial" &&
              createSubsFormData.installment1Mode?.value === "online") ||
            (createSubsFormData.selectedTrxMode?.value === "dual" &&
              parseFloat(createSubsFormData.onlineAmount) > 0)) && (
            <div className="formInputBox">
              <label htmlFor="enteredTrxId" className="formInputLabel">
                Transaction ID <span className="required">*</span>
              </label>

              <input
                type="text"
                className={`formInput ${
                  createSubsFormErrors.enteredTrxId && "formError"
                }`}
                placeholder={
                  createSubsFormData.selectedTrxMode?.value === "partial"
                    ? "Ref for 1st installment (online)"
                    : "Enter Transaction ID"
                }
                name="enteredTrxId"
                value={createSubsFormData.enteredTrxId}
                onChange={(e) =>
                  setCreateSubsFormData({
                    ...createSubsFormData,
                    enteredTrxId: e.target.value,
                  })
                }
              />
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="enteredStartDate" className="formInputLabel">
              Subscription Start Date <span className="required">*</span>
            </label>

            <input
              type="date"
              className={`formInput ${
                createSubsFormErrors.enteredStartDate ? "formError" : ""
              } ${createSubsFormData.enteredStartDate ? "date-has-value" : ""}`}
              name="enteredStartDate"
              value={createSubsFormData.enteredStartDate}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  enteredStartDate: e.target.value,
                })
              }
              min={currentMonthCurrentDate}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="extendDays" className="formInputLabel">
              Extend Days
            </label>

            <input
              type="number"
              className="formInput"
              placeholder="0"
              name="extendDays"
              value={createSubsFormData.extendDays}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  extendDays: e.target.value,
                })
              }
              min="0"
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="enteredExpireDate" className="formInputLabel">
              Subscription Expire Date <span className="required">*</span>
            </label>

            <input
              type="date"
              className={`formInput ${
                createSubsFormErrors.enteredExpireDate ? "formError" : ""
              } ${
                createSubsFormData.enteredExpireDate ? "date-has-value" : ""
              }`}
              name="enteredExpireDate"
              value={createSubsFormData.enteredExpireDate}
              readOnly
              style={{ cursor: "not-allowed", backgroundColor: "#f5f5f5" }}
              min={currentMonthCurrentDate}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="paymentDate" className="formInputLabel">
              Payment Date
            </label>

            <input
              type="date"
              className={`formInput ${
                createSubsFormData.paymentDate ? "date-has-value" : ""
              }`}
              name="paymentDate"
              value={createSubsFormData.paymentDate}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  paymentDate: e.target.value,
                })
              }
            />
          </div>
        </div>

        {/* SELECT SLOT */}
        {(createSubsFormData.selectedType?.value === "addon" ||
          createSubsFormData.selectedType?.value === "addon_pt") &&
          createSubsFormData.selectedTrainer?.value && (
            <>
              {allTrainersSlotData?.length > 0 ? (
                <div className="formInputsGrid singleGrid flexWrapMultiBoxontainer bgTransparentShadowNone slotsContainer">
                  <div className="formInputBox">
                    <label htmlFor="selectedSlotID" className="formInputLabel">
                      Slots <span className="required">*</span>
                    </label>

                    <div
                      className={`flexWrapMultiBoxontainerSub ${
                        createSubsFormErrors.selectedSlotID && "formError"
                      }`}
                    >
                      {allTrainersSlotData?.map((slot, index) => (
                        <div
                          className={`wrappedBox ${
                            slot?.is_available === false ? "disabledSlot" : ""
                          } ${
                            createSubsFormData.selectedSlotIndex === index
                              ? "selected"
                              : ""
                          }`}
                          style={{
                            cursor:
                              slot?.is_available === false
                                ? "not-allowed"
                                : "pointer",
                          }}
                          key={index}
                          onClick={() =>
                            slot?.is_available !== false &&
                            handleSelectSlot(
                              index,
                              slot?.start_time,
                              slot?.end_time,
                              slot?.slot_id
                            )
                          }
                          disabled={slot?.is_available === false}
                        >
                          <span className="wappedValueLabel textSmol">
                            {`${moment(slot?.start_time, "HH:mm").tz("Asia/Kolkata").format(
                              "h:mm A"
                            )} - ${moment(slot?.end_time, "HH:mm").tz("Asia/Kolkata").format(
                              "h:mm A"
                            )}` || "-"}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <span className="errorMessage">Slots Not Available</span>
              )}
            </>
          )}
        {/* ------------------- SELECT SLOT  ------------------- */}

        {/* GST CALCULATION TABLE */}
        <div className="chargesTableContainer">
          <table className="chargesTable">
            <thead>
              <tr>
                <th>Charges</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Amount</th>
                <td>₹{gstTableValues.amount || "-"}</td>
              </tr>
              <tr>
                <th>Taxable Amount</th>
                <td>₹{gstTableValues.taxableAmount || "-"}</td>
              </tr>
              <tr>
                <th>SGST</th>
                <td>₹{gstTableValues.sgst || "-"}</td>
              </tr>
              <tr>
                <th>CGST</th>
                <td>₹{gstTableValues.cgst || "-"}</td>
              </tr>
              <tr>
                <th style={{ borderBottom: "none" }}>
                  <strong>Total Amount</strong>
                </th>
                <td style={{ borderBottom: "none" }}>
                  <strong>₹{gstTableValues.totalAmount || "-"}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* -------------------- GST CALCULATION TABLE -------------------- */}

        <div
          className="formButtons"
          style={{ justifyContent: "flex-end", marginTop: "20px" }}
        >
          <Button className="saveBtn" variant="danger" onClick={onClickSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Processing..." : "Add Subscription"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddSubscription;
